<template>
  <div>
    <Notification
      v-for="(item, i) in items"
      :key="item.id"
      v-bind="item"
      :timeout="item.persistent ? -1 : timeout"
      :is-visible="i === 0"
      :hide-close-button="items.length > 1"
      @remove="removeItem"
    >
      <v-btn
        v-if="items.length > 1"
        text
        small
        @click="removeItem(item.id)"
      >
        Next ({{ items.length - 1 }} more)
      </v-btn>
    </Notification>
  </div>
</template>
<script>
import Notification from '../../atoms/notification/notification';

export default {
  name: 'NotificationQueue',
  components: {
    Notification,
  },
  props: {
    items: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      timeout: 10000,
      timeoutId: null,
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    items() {
      this.processItems();
    },
  },
  methods: {
    processItems() {
      if (this.items && Array.isArray(this.items) && this.items.length > 0) {
        const item = this.items[0];
        if ((item.hideForRoutes || []).includes(this.routeName)) {
          this.removeItem(item.id);
        } else if (!item.persistent) {
          this.timeoutId = setTimeout(() => {
            this.removeItem(item.id);
          }, this.timeout);
        }
      }
    },
    removeItem(id) {
      clearTimeout(this.timeoutId);
      this.$emit('remove', id);
    },
  },
};
</script>
